import { CurrencyCode } from "@acto/taskpane/core/utils/currencyCode";
import { formatCurrencyValue } from "@acto/taskpane/core/utils/currencyPattern";

export const formatCurrency = (value: number | null, locale: string, currency: CurrencyCode): string => {
  if (value === null) return "-";

  return formatCurrencyValue(Math.round(value), locale, currency, {
    maximumFractionDigits: 0,
  });
};

export const formatChange = (value: number | null): string => {
  if (value === null) return "";
  const rounded = Math.round(value);
  const signed = rounded >= 0 ? `+${rounded}` : `${rounded}`;
  return `${signed}%`;
};

export const formatChangePercentage = (value: number): string => {
  const sign = value >= 0 ? "+" : "";
  return `${sign}${value}%`;
};

export const formatMargin = (value: number, locale: string): string => {
  const percentage = value * 100;
  const rounded = Math.round(percentage * 10) / 10;
  const normalized = Object.is(rounded, -0) ? 0 : rounded;
  return `${normalized.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};

export const formatProfitWithMargin = (
  profit: number | null,
  margin: number | null,
  locale: string,
  currency: CurrencyCode,
): string => {
  if (profit === null && margin === null) return "-";

  const profitStr = formatCurrency(profit, locale, currency);
  if (margin === null) return profitStr;

  const marginStr = formatMargin(margin, locale);
  if (profit === null) return marginStr;

  return `${profitStr} (${marginStr})`;
};
